(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ROR.Intro",
                {
                    url: "/Intro",
                    component: "intro",
                    PageTitle: "Introduction Message",
                    //requiredPermissions: "NewAccountWizard:View",
                    resolve: {
                        userMasterAdvisorAgreement: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getLoggedInUserMasterAdvisorAgreement().then(function (agreement) {
                                return agreement;
                            }, function () {
                                return null;
                            });
                        }],
                        userOnbordingRecord: ["onboardingApi", function (onboardingApi) {                         
                            return onboardingApi.getLoggedInUserOnboarding().then(function (record) {
                                return record;
                            }, function () {
                                return null;
                            });
                        }],
                        rorSteps: ["masterAdvisorAgreementRequiredRecord", "userOnbordingRecord", "userMasterAdvisorAgreement", function (masterAdvisorAgreementRequiredRecord, userOnbordingRecord, userMasterAdvisorAgreement) {
                            var steps = [];

                            if (userOnbordingRecord != null) {
                                if (masterAdvisorAgreementRequiredRecord != null)
                                    steps.push({
                                        step: "agreement",
                                        description: "Sign Master Advisor Agreement",
                                        complete: userMasterAdvisorAgreement != null ? true : false
                                    });

                                steps.push({
                                    step: "validate",
                                    description: "Validate your Personal Information",
                                    complete: userOnbordingRecord.InfoValidated != null ? true : false
                                });

                                steps.push({
                                    step: "getcontracted",
                                    description: "Get Contracted!",
                                    complete: false
                                });
                            }
                            return steps;
                        }]
                    }
                });
        }
    ]);

    app.component("intro",
        {
            templateUrl: "App/RORWizard/Intro/intro.html",
            controller: introCtrl,
            bindings: {
            }
        });

    introCtrl.$inject = ["$http", "permissionService", "$state"];

    function introCtrl($http, permissionService, $state) {
        var $ctrl = this;


        $ctrl.UI = {};
        //$ctrl.UI.prevStage = "";
        $ctrl.UI.nextStage = "steps"

        $ctrl.changeStage = function (goToStage) {
            if (goToStage === "steps") {
                $state.go("Home.ROR.Steps");
            }          
        }

    }
})(window.app, window.angular); // jshint ignore:line